import {Formik} from "formik";
import CustomTabMenu from "../component/CustomTabMenu";
import {danhSachTabCGKT} from "./Components/Tabs";
import {useMemo} from "react";

export const ChuyenGiaoKyThuat: React.FC = () => {
  const tabs = useMemo(() => danhSachTabCGKT(), []);
  return (
    <Formik<any> initialValues={{}} onSubmit={() => {
    }}>
      <div className="bg-white h-100">
        <div className="flex-1 flex flex-column">
          <CustomTabMenu
            childrenTab
            danhsachTabs={tabs}
            className="spaces pl-0"
          />
        </div>
      </div>
    </Formik>
  );
};

export default ChuyenGiaoKyThuat;
